/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric, Button, Loader, SelectGeneric, TextArea, Rating } from 'ypf-pas-general-ui-components';
import { BsBoxArrowInUpRight } from 'react-icons/bs';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { getMotivesLowScore } from '../../../services/workReport';
import { putFinalizeServiceMonthly } from '../../../services/monthlyServiceRequest';
import { putFinalizeService } from '../../../services/serviceRequest';
import useToast from '../../../hooks/useToast';
import { checkRol } from '../../../security';
import { aprobador } from '../../../security/constantsRols';
import { assignmentTypeEnum } from '../../../utils/dataStatus';
import '../../WellForm/WellForm.scss';
import './EndServiceModal.scss';

const EndServiceModal = ({ show, onHide, lineInfo, tipoAsignacion }) => {
  const [motive, setMotive] = useState(null);
  const [message, setMessage] = useState(null);
  const [rate, setRate] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [listMotives, setListMotives] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { setNewToast } = useToast();

  const handleMotive = (e) => {
    setMotive({
      value: e.value,
      label: e.label
    });
  };

  const handleMessage = (e) => {
    e.preventDefault();
    setMessage(e.target.value);
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getMotivesLowScore();

      setListMotives(res);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }

    setLoading(false);
  };

  const endServiceAction = async () => {
    setLoading(true);
    try {
      const id = lineInfo.idSolicitudServicio;
      const body = {
        comentario: message,
        calificacion: rate === 0 ? null : rate,
        motivoBajaCalificacionEnum: motive ? motive.value : null
      };

      const res =
        tipoAsignacion !== assignmentTypeEnum.Mensualizada
          ? await putFinalizeService(id, body)
          : await putFinalizeServiceMonthly(id, body);

      setNewToast({
        type: 'SUCCESS',
        message: res.mensaje
      });

      onHide();
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!show) {
      setRate(0);
      setMotive(null);
      setMessage(null);
      setIsDisabled(false);
    }
    if (show) {
      fetchData();
    }
  }, [show]);

  useEffect(() => {
    // Deshabilita el boton secundario si:
    // Rate 1 estrella y no completo Motivo y comentario
    if (rate === 1) {
      if (motive && message) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    }
  }, [rate, message, motive]);

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onHide}
      primaryAction={onHide}
      primaryActionLabel="Salir"
      primaryActionVariant="primary"
      secondaryAction={endServiceAction}
      secondaryActionDisabled={isDisabled}
      secondaryActionLabel={rate === 0 ? 'Finalizar sin evaluar' : 'Finalizar servicio'}
      secondaryActionVariant="outline-danger"
      show={show}
      size="xl"
      title="Finalizar servicio"
    >
      <>
        <div className="endservice-modal">
          <div className="object-pills ubication-info mb-2 mt-1">
            <div className="pills">
              <h6 className="pill light">{lineInfo?.ubicacion}</h6>
            </div>
          </div>
          <div className="sds-info">
            <p className="sds-number">
              {lineInfo?.numeroSolicitudServicio}
              {checkRol(aprobador) && (
                <Button
                  icon={BsBoxArrowInUpRight}
                  onClick={() => {
                    onHide();
                    if (tipoAsignacion !== assignmentTypeEnum.Mensualizada) {
                      history.push(`/detail/${lineInfo?.idSolicitudServicio}`);
                    } else {
                      history.push(`/detailmonthly/${lineInfo?.idSolicitudServicio}`);
                    }
                  }}
                  type="button"
                  variant="light-gray"
                  widthButton="30px"
                />
              )}
            </p>
            <span className="divider">|</span>
            <p>{lineInfo?.servicioAsociado}</p>
            <span className="divider">|</span>
            <p>{lineInfo?.proveedor}</p>
          </div>

          <div className="endservice-view">
            <div className="rate-container">
              <span className="rate-txt">Calificar el servicio ofrecido </span>
              <Rating canChange={false} quantity={5} setRate={setRate} />
            </div>
            {rate === 1 ? (
              <>
                <SelectGeneric
                  defaultValueOneOption={false}
                  label="Motivo por baja calificación*"
                  name="motive"
                  onChange={handleMotive}
                  optionMapper={{
                    value: 'id',
                    label: 'nombre'
                  }}
                  options={listMotives}
                  paddingIndicator={4}
                  placeholder="Selecciona el motivo"
                  value={motive}
                  withSelect="97%"
                />

                <TextArea
                  className="text_area"
                  label="Comentario*"
                  maxLength={512}
                  name="comment"
                  onChange={(e) => handleMessage(e)}
                  placeholder="Motivos sobre tu calificación"
                  resize={false}
                  value={message}
                />
              </>
            ) : null}
            <div className="bottom-txt-container">
              <span className="red-txt">
                Al finalizar el servicio no se podrán agregar más cantidades a las posiciones y
                líneas
              </span>
            </div>
          </div>
        </div>
        <Loader show={loading} text="CARGANDO" />
      </>
    </ModalGeneric>
  );
};

export default EndServiceModal;

EndServiceModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  lineInfo: PropTypes.objectOf(
    PropTypes.shape({
      detalleDeLinea: PropTypes.string,
      equipo: PropTypes.arrayOf(),
      evento: PropTypes.string,
      idSolicitudServicio: PropTypes.number,
      numeroSolicitudServicio: PropTypes.string,
      proveedor: PropTypes.string,
      ubicacion: PropTypes.string
    })
  ),
  tipoAsignacion: PropTypes.number
};

EndServiceModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  lineInfo: null,
  tipoAsignacion: null
};
